import React from 'react'
import { useIntl } from 'react-intl'
import { Text } from '@contrast-security-inc/design-system-typography'

export const DiagnosticCollectionInfo = () => {
  const { formatMessage } = useIntl()
  return (
    <Text font="body">
      {formatMessage({ id: 'detail_servers_enableDiagnosticCollection_info' })}
    </Text>
  )
}
